import React from "react";

import { FormControl } from "kanopi-components/Input";
import { CurrencyInput } from "kanopi-components/NumberInput";

import { WidthContainer } from "../../ChatFlow/WidthContainer";
// Define the interface for the specific props of RevenueInput
interface RevenueInputProps {
  label?: string;
  title?: string;
  help?: string;
  error?: boolean;
  size?: "compact" | "mini" | "large"; // Assuming 'size' is restricted to these values
  hideLabel?: boolean;
  // Add any specific types for additional props that CurrencyInput accepts
  [key: string]: unknown; // This allows passing additional props to CurrencyInput
}

export function RevenueInput({
  label,
  title,
  help,
  error,
  size,
  hideLabel,
  ...props
}: RevenueInputProps) {
  return (
    <WidthContainer size={size}>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
      >
        <CurrencyInput error={error} size={size} {...props} />
      </FormControl>
    </WidthContainer>
  );
}
